<template>
    <div>
        <div class="nav_box">
            <div class="back_span" @click="back">
                <Icon type="ios-arrow-back" size="18" />
                返回上一页
            </div>

        </div>
    </div>
</template>

<script>

export default {
    name: 'h5_nav',
    props: [
        'back_path'
    ],

    methods: {
        back() {
            var path = this.back_path
            console.log(path)
            this.$router.push({
                path: path
            })
        }
    }

}
</script>

<style  scoped>
.back_span {
    color: #fff;
    display: flex;
    align-items: center;
}

.nav_box {
    padding-left: 10px;
    height: 50px;
    background-color: #0466dd;
    width: 100%;
    display: flex;
    align-items: center;
}
</style>